<div class="modal-container d-flex flex-column h-100">
    <div class="modal-header border-0 justify-content-start">
      <h1 class="modal-title text-center text-primary-color ps-2">{{ title }}</h1>
    </div>
    <div class="modal-body">
      <textarea class="form-control snBox mb-2 font-12 text-light-gray"
       rows="6" 
       [(ngModel)]="data.value"
       (ngModelChange)="updateCount(data?.value)">
      </textarea>
      <span class="font-14 text-gray">Total Records: {{ totalCount }}</span>
    </div>
    <div class="modal-footer border-0 justify-content-end">
      <div class="m-0 d-flex gap-3">
        <app-button [buttonType]="'button'" [button_2]="true"
                    [buttonClass]="'button-info button popup-button'"
                    [buttonLable]="enumButtonName.CANCEL" 
                    (click)="activeModal.close({ title, confirm: false })"></app-button>
        <app-button [buttonType]="'button'" [button_2]="true"
                    [buttonClass]="totalCount > 0 || data?.title == 'Edit' ? 'button-primary button popup-button' : 'button-info button popup-button'"
                    [buttonLable]="data?.title"
                    [ngClass]="{'cursor-not-allowed':data?.disable}"
                     (click)="totalCount == 0 && data?.title == 'Save'?'':onEditClick()"></app-button>
      </div>
    </div>
  </div>
  